













import { Component, Vue } from 'vue-property-decorator';

import axios from 'axios';

import CreateEditCompanyForm from '@/components/CreateEditCompanyForm.vue';
import { Company } from '@/lib/models';

@Component({
  components: {
    CreateEditCompanyForm,
  },
})
export default class CreateCompany extends Vue {
  private submitting: boolean = false;

  private async createCompany(company: Company): Promise<void> {
    this.submitting = true;
    const url: string = `${process.env.VUE_APP_BACKEND_API_HOST}/companies`;
    const accessToken: string = await (this as any).$auth0.getAccessTokenSilently();
    axios.post(url, company, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }).then((response) => {
      const message: string = `Successfully created company: ${company.name}`;
      this.$bvModal.msgBoxOk(message, {
        title: 'Company Created',
        okVariant: 'success',
        centered: true,
      }).then(() => {
        this.$router.push({ name: 'companies' });
      });
    }).catch((error) => {
      const message: string = error.response?.data?.message ?? error.message;
      this.$bvModal.msgBoxOk(message, {
        title: 'Error Creating Company',
        okVariant: 'danger',
        centered: true,
      });
    }).finally(() => {
      this.submitting = false;
    });
  }
}
